import { ErrorBlock, AutoCenter, Button, Divider, Result, Dialog, Toast } from 'antd-mobile'
import './index.css'
import { memo, ReactNode, useEffect, useRef, useState } from 'react'
import request from '../../utils/request'
import { useMount } from 'ahooks'

type Iprops = {
  label: ReactNode,
  value: ReactNode,
}

function splitByReg3 (str: string) {
  const re = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
  return str.replace(re, "$1,");
}

function randomString() {
  let len = 32;
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let maxPos = chars.length;
  let character = '';
  for (let i = 0; i < len; i++) {
      character += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return character;
}

const FlextItem = memo<Iprops>(({ label, value }) => {
  return (
    <div className='Flex_Item'>
      <div style={{ minWidth: '6em' }}>{label}</div>
      <div>{value}</div>
    </div>
  )
})

const Home = () => {
  // const [openid, setOpenid] = useState<string>()
  const [data, setData] = useState<any>()
  const [status, setStatus] = useState<any>()
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  const param: any = params.get('param')
  const [applyId, recordId] = param?.split('_')
  const getStatusInfo = async () => {
    const statusInfo: any = await request.post('/api/workOrder/wx/queryWxPayByRecordId', {
      recordId,
    })
    setStatus(statusInfo?.status)
    setData({
      ...statusInfo,
      amount: statusInfo?.total / 100,
      prepayId: undefined,
    })
    return statusInfo
  }
  useMount(async () => {
    if (recordId) {
      const statusInfo = await getStatusInfo()
      if (statusInfo?.status !== 'SUCCESS') {
        if (!code) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx105f9aa9498e6998&redirect_uri=${encodeURI(window.location.href)}&response_type=code&scope=snsapi_base#wechat_redirect`
        } else {
          const res: any = await request.post('/api/workOrder/wx/getOpenId', {
            code,
          })
          const res2 = await request.post('/api/workOrder/orderFormMoneyRecord/onlinePrepayRecord', {
            recordId,
            applyId,
            openId: res.openid,
          })
          setData(res2)
        }
      }
    }
  })

  const submitPay = async () => {
    const dateNow = `${Date.now()}`
    const params = {
      timeStamp: dateNow.slice(0, dateNow.length - 3),
      nonceStr: randomString(),
      package: `prepay_id=${data?.prepayId}`,
    }
    const signRes = await request.post('/api/workOrder/wx/wxPaySign', {
      ...params,
      packageStr: params.package,
    })
    // @ts-ignore
    WeixinJSBridge.invoke('getBrandWCPayRequest', {
      ...signRes,
      ...params,
      signType: 'RSA',
    }, async function (res: any) {
      if (res.err_msg === "get_brand_wcpay_request:ok") {
        Dialog.show({
          content: '是否支付已完成？',
          closeOnAction: true,
          onAction: () => {
            getStatusInfo()
          },
          actions: [[{
            key: 'cancel',
            text: '未支付',
            danger: true,
          }, {
            key: 'submit',
            text: '已支付',
            danger: true,
          }]],
        })
      }
    })
  }
  if (status === 'SUCCESS') {
    return <Result
      status='success'
      title='付款成功'
      description='您已经成功付款，请勿重复点击链接操作，如需重新付款请联系对应销售发送付款链接'
    />
  }
  return (
    <div className='Home_Index'>
      <div className='Main_Content'>
        <AutoCenter style={{ marginTop: 20 }}>向{data?.collectionEntityName}付款</AutoCenter>
        <AutoCenter style={{ fontSize: 24, marginBlock: 20  }}>￥{splitByReg3((data?.amount || 0).toFixed(2))}</AutoCenter>
        <AutoCenter><Button disabled={!data?.prepayId} onClick={() => submitPay()} size='middle' style={{ width: 'calc(100vw - 80px)' }} type='submit' color='primary'>付款</Button></AutoCenter>
      </div>
      <Divider />
      <div className='Desc_Content'>
        <FlextItem label='发起人' value={data?.submitterName} />
        <FlextItem label='收款人' value={data?.collectionEntityName} />
        <FlextItem label='付款人' value={data?.customerName} />
        <FlextItem label='服务项目' value={data?.productName} />
      </div>
    </div>
  )
  return (
    <ErrorBlock status='empty' title='链接已失效' description='请联系销售人员重新发送链接' />
  )
}

export default Home